import React from 'react'

import BasicRoute from 'components/routes/BasicRoute'

import OperadorConsulta from 'entity/Operador/components/OperadorConsulta'
import OperadorForm from 'entity/Operador/components/OperadorForm'

export default function RoutesMenusOperador() {
    return (
        <>
            <BasicRoute
                perfilAuth={['r9jrEQXznNgjrZTGCfch', 'RECT03jkyTQW9B2OMz47']}//admin ou tecnico
                uid="consulta-operador"
                route="consulta-operador"

                menuProps={{
                    text: "Operadores",
                    sequence: "111119",
                    iconName: "Engineering",

                    parent: {
                        uid: "parentCadastros",
                        text: "Cadastros",
                        sequence: "222222",
                        iconName: 'Edit'
                    }
                }}

                element={<OperadorConsulta />}
            />
            <BasicRoute
                uid="operador"
                route="_operador"
                element={<OperadorForm />}
            />
        </>
    )
}
